import { Component, OnInit, OnDestroy } from '@angular/core';
import { Store } from '@ngxs/store';
import { Observable, Subscription } from 'rxjs';
import { AcceleratorStatus } from './accelerator.service';
import { AcceleratorStatusStateModel } from './store/accelerator-status.state';

@Component({
  selector: 'app-accelerator-status',
  templateUrl: './accelerator-status.component.html',
  styleUrls: ['./accelerator-status.component.scss']
})
export class AcceleratorStatusComponent implements OnInit, OnDestroy {

  public acceleratorStatus$: Observable<AcceleratorStatusStateModel>;
  public accStatusSubscription: Subscription;
  public acceleratorStatus!: AcceleratorStatus[];
  public loading: boolean;

  constructor(
    private store: Store
  ) {
    this.loading = true;
    this.acceleratorStatus$ = this.store.select(state => state.AcceleratorStatus);
    this.accStatusSubscription = this.acceleratorStatus$.subscribe(state => {
      this.loading = state.loading;
      const acceleratorStatus = state.acceleratorStatus;
      if (acceleratorStatus?.length) {
        acceleratorStatus.map(accelerator => {
          accelerator.moreInfo = accelerator.documents.length ? accelerator.documents.join(' ') : '';
        });
        this.acceleratorStatus = acceleratorStatus;
      }
    });
  }

  ngOnDestroy(): void {
    this.accStatusSubscription.unsubscribe();
  }

  ngOnInit() {
  }

  getClass(text: string) {
    let style = '';
    if (text) {
      style = text.trim().toLowerCase();
    }
    switch (style) {
      case 'not ready': return 'badge badge-warning';
      case 'ready': return 'badge badge-primary';
      default: return 'badge badge';
    }
  }

}
